import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

import BasicComponent from './BasicComponent';
import AccountComponent from './AccountComponent';
import BookingComponent from './BookingComponent';
import RulesComponent from './RulesComponent';
import './index.css';

class Intro extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  contentSelector = id => {
    if (this.props.operatingCity === 'new_york') {
      switch (id) {
        default:
        case '1':
          return <BasicComponent id={id} {...this.props} />;
        case '2':
          return <BookingComponent id={id} {...this.props} />;
        case '3':
          return <RulesComponent id={id} {...this.props} />;
      }
    } else {
      switch (id) {
        default:
        case '1':
          return <BasicComponent id={id} {...this.props} />;
        case '2':
          return <AccountComponent id={id} {...this.props} />;
        case '3':
          return <BookingComponent id={id} {...this.props} />;
        case '4':
          return <RulesComponent id={id} {...this.props} />;
      }
    }
  };

  render() {
    const { id } = this.props.match.params;
    return <Fragment>{this.contentSelector(id)}</Fragment>;
  }
}

export default withRouter(Intro);



// WEBPACK FOOTER //
// ./src/components/Intro/index.js